import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import churchDashboardService from '@/services/church-dashboard.service';

type DismissAllNotificationsVariables = {
  churchId: string;
};

export const useDismissAllNotificationsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ churchId }: DismissAllNotificationsVariables) =>
      churchDashboardService.dismissAllNotifications({ churchId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.DASHBOARD_NOTIFICATIONS] });
    },
  });
};
